import(/* webpackMode: "eager" */ "/opt/buildhome/repo/app/[locale]/login/page.tsx");
